import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/projectCategories')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/projectCategory' })
  },
})
